import React, {useState} from 'react';
import {Button, Calendar, DateBox} from "devextreme-react";
import CalendrierLegende from './calendrier-legende';
import PopView from "./pop-view";
import {useCalendrierProps} from "./calendrier";

interface CalendrierLeftZoneProps {
    dateCourrante: Date,
    onValueChanged: any
}

const CalendrierLeftZone = ({dateCourrante, onValueChanged}: CalendrierLeftZoneProps) => {
    const [isPopResidentOpen, setIsPopResidentOpen] = useState(false);
    const {selectedTypeUnite} = useCalendrierProps();
    const calDateDebut = new Date(selectedTypeUnite?.calDateDebut?.toLocaleDateString() || new Date(dateCourrante.getFullYear(), 0, 1));
    const calDateFin = new Date(selectedTypeUnite?.calDateFin?.toLocaleDateString() || new Date(dateCourrante.getFullYear(), 11, 31));

    return (
        <div style={{height: "100%", display: "flex", gap: "1rem", flexDirection: "column", alignItems: "center"}}>
            <div>
                <DateBox value={dateCourrante} onValueChanged={onValueChanged}/>
                <Calendar value={dateCourrante} onValueChanged={onValueChanged} showTodayButton disabledDates={(args) => {
                    return calDateDebut.getMonth() < calDateFin.getMonth() ?
                        !(args.date.getMonth() >= calDateDebut.getMonth() && args.date.getMonth() <= calDateFin.getMonth() || args.date.getMonth() == calDateDebut.getMonth() && args.date.getDate() >= calDateDebut.getDate() || args.date.getMonth() == calDateFin.getMonth() && args.date.getDate() <= calDateFin.getDate()) :
                        args.date.getMonth() > calDateFin.getMonth() && args.date.getMonth() < calDateDebut.getMonth() || args.date.getMonth() == calDateFin.getMonth() && args.date.getDate() > calDateFin.getDate() || args.date.getMonth() == calDateDebut.getMonth() && args.date.getDate() < calDateDebut.getDate();
                }}/>
                <CalendrierLegende/>
            </div>
            <div style={{justifyContent: "end"}}>
                <Button text={"Liste des résidents"} onClick={() => setIsPopResidentOpen(prev => !prev)}/>
            </div>
            {/* <div style={{ justifyContent: "end" }}>
                <input type='number' value={nbColonne}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    if (value > 0) setNbColonne(value);
                  }} />
              </div> */}
            {/* setNbColonne(typeUnite?.nombreColonnes || 1) */}
            <PopView isVisible={isPopResidentOpen} togglePopup={() => setIsPopResidentOpen(prev => !prev)}/>
        </div>
    )
}
export default CalendrierLeftZone;